import { render, staticRenderFns } from "./iconRetractSidenav.vue?vue&type=template&id=1456088a&scoped=true&"
import script from "./iconRetractSidenav.vue?vue&type=script&lang=js&"
export * from "./iconRetractSidenav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1456088a",
  null
  
)

export default component.exports